// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import Badge, { BadgeTypeValues } from "@insite/mobius/Badge";
import { isPreviouslyPurchased } from "@werner/App/Store/Selectors/ProductSelectors";
import { BadgePresentationProps } from "@werner/MobiusOverrides/Badge/Badge";
import { color } from "@werner/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

interface OwnProps extends BadgePresentationProps {
    product?: CartLineModel | ProductContextModel | ProductModel;
}

const PreviouslyPurchasedBadge = ({ product, ...otherProps }: OwnProps) => {
    if (!product) {
        return null;
    }
    const productModel = "product" in product ? product.product : product;
    const isPrevPurchased = isPreviouslyPurchased(productModel);

    if (!isPrevPurchased) {
        return null;
    }
    return (
        <Badge
            type={BadgeTypeValues.Text}
            value={translate("<<PURCHASED")}
            badgeBackgroundColor="fff"
            badgeTextColor="369CD6"
            badgeTextRounding={14}
            {...otherProps}
        />
    );
};

export default PreviouslyPurchasedBadge;
